import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { NotificationsRoutingModule } from '@app/modules/notifications/router';
import { NotificationsState } from '@app/modules/notifications/store/notifications.state';
import { NotificationsService } from '@app/modules/notifications/service/notifications.service';
import { NotificationSidebarComponent } from '@app/modules/notifications/part/notification-sidebar/notification-sidebar.component';
import { NotificationItemComponent } from '@app/modules/notifications/part/notification-item/notification-item.component';
import { InvitationsPartComponent } from './part/invitations-part/invitations-part.component';
import { DoctorBlockerComponent } from './part/doctor-blocker/doctor-blocker.component';

const imports = [
  CommonModule,
  SharedModule,
  NotificationsRoutingModule,
  NgxsModule.forFeature([NotificationsState]),
];

const declarations = [
  NotificationSidebarComponent,
  NotificationItemComponent,
  InvitationsPartComponent,
  DoctorBlockerComponent,
];

const providers = [NotificationsService];

@NgModule({
  imports,
  declarations,
  providers,
  exports: [...declarations],
})
export class NotificationsModule {}
